import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DemoService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  addDemoLog(step1Finished: boolean, step2Finished: boolean): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/demo/add`, {step1Finished, step2Finished});
  }

  updateDemoLog(demoLog: any) {
    return this.http.post<any>(`${this.baseUrl}/demo/update`, {demoLog});
  }
}
